import { gql } from '@apollo/client';

export const GET_PAGE = gql`
  query GetPage($slug: String!) {
    pageBySlug(slug: $slug) {
      id
      title
      subtitle
      content
      excerpt
      metaTitle
      metaDescription
      metaKeywords
      template
      createdAt
      updatedAt
    }
  }
`;

export const GET_FOOTER_PAGES = gql`
  query GetFooterPages($column: Int) {
    footerPages(column: $column) {
      id
      title
      slug
      footerColumn
      order
    }
  }
`;

export const GET_HEADER_PAGES = gql`
  query GetHeaderPages {
    headerPages {
      id
      title
      slug
      icon
      order
    }
  }
`;

export const GET_PUBLISHED_PAGES = gql`
  query GetPublishedPages {
    publishedPages {
      id
      title
      slug
      subtitle
      excerpt
      order
    }
  }
`;
